import classNames from "classnames";
import AppContext from "PFApp/app_context";
import { Typography } from "PFComponents/typography";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { NavigationPill } from "../components/navigation_pill";
import { MarketplacePage } from "../constants";
import { useNavigationItems } from "../hooks/use_navigation_items";
import css from "./dashboard.module.scss";
import { MyPreferences } from "./parts/my_preferences";
import { NextAvailability } from "./parts/next_availability";
import { Opportunities } from "./parts/opportunities";
import { ProfileCompletion } from "./parts/profile_completion";
import { Quote } from "./parts/quote";
import { UpcomingRoles } from "./parts/upcoming_roles/upcoming_roles";

export const Dashboard = (): JSX.Element => {
  const { t } = useTranslation("marketplace", { keyPrefix: "dashboard" });
  const {
    store: {
      currentProfile,
      appLayout: { leftActionPanel }
    }
  } = useContext(AppContext);
  const items = useNavigationItems();

  const notificationsOpened = !leftActionPanel.collapsed;

  return (
    <div
      className={classNames(css.dashboardPageContainer, { [css.notificationsOpened]: notificationsOpened })}
    >
      <div className={classNames(css.dashboardPage, { [css.notificationsOpened]: notificationsOpened })}>
        <Quote className={css.leftColumn} notificationsOpened={notificationsOpened} />
        <div className={css.rightColumn}>
          <div className={css.header}>
            <Typography variant="h5" className={css.welcomeText} noMargin>
              {t("welcomeText", { name: currentProfile.first_name })}
            </Typography>
            <NavigationPill<MarketplacePage> activeItemId={MarketplacePage.Dashboard} items={items} />
          </div>
          <div className={css.tilesRows}>
            <div className={css.row}>
              <Opportunities />
            </div>
            <div className={css.row}>
              <NextAvailability />
              <ProfileCompletion />
              <MyPreferences />
            </div>
            <div className={css.row}>
              <UpcomingRoles />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
